import type { Swiper as SwiperClass } from 'swiper/types';

import { useEffect, useMemo, useState } from 'react';

import { useComparison } from '@screens/Comparison';
import { CATEGORY_ATTRIBUTES } from '@screens/Product/model/config/path';
import { useAppDispatch } from '@shared/hooks/redux';

import { getSlidesQuantity } from '../../utils/getSlidesQuantity/getSlidesQuantity';
import { CardsSlider } from './CardsSlider/CardsSlider';
import { CharacteristicsSlider } from './CharacteristicsSlider/CharacteristicsSlider';
import { FixedSlider } from './FixedSlider/FixedSlider';
import cls from './ProductList.module.scss';

export const ProductList = () => {
  const dispatch = useAppDispatch();
  const [mainSlider, setMainSlider] = useState<SwiperClass | null>();
  const [fixedSlider, setFixedSlider] = useState<SwiperClass | null>();

  const { products, productCharacteristics, activeCategory, changeSlide } = useComparison();

  const minQuantitySlides = Object.values(products?.[activeCategory])?.length > getSlidesQuantity();

  const characteristics = useMemo(
    () =>
      productCharacteristics?.find(
        (el) => el.name.toLowerCase().trim() === CATEGORY_ATTRIBUTES[activeCategory].toLowerCase().trim()
      )?.groups,
    [activeCategory, productCharacteristics]
  );

  useEffect(() => {
    if (!mainSlider) return;
    changeSlide(
      mainSlider.realIndex,
      minQuantitySlides && !mainSlider.isBeginning,
      minQuantitySlides && !mainSlider.isEnd
    );
  }, [minQuantitySlides, mainSlider, activeCategory, dispatch, changeSlide]);

  return (
    <div className={cls.wrap}>
      <FixedSlider
        fixedSlider={fixedSlider}
        setFixedSlider={setFixedSlider}
        mainSlider={mainSlider}
      />
      <CardsSlider
        mainSlider={mainSlider}
        setMainSlider={setMainSlider}
        fixedSlider={fixedSlider}
      />
      <CharacteristicsSlider {...{ characteristics }} />
    </div>
  );
};
